import { render, staticRenderFns } from "./waterRecord.vue?vue&type=template&id=ceba22b0&scoped=true&"
import script from "./waterRecord.vue?vue&type=script&lang=js&"
export * from "./waterRecord.vue?vue&type=script&lang=js&"
import style0 from "./waterRecord.vue?vue&type=style&index=0&id=ceba22b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceba22b0",
  null
  
)

export default component.exports